import React, { ReactElement, useState } from "react"
import PowerSettingsNewIcon from "@material-ui/icons/PowerSettingsNew"
import {
	Dialog,
	DialogTitle,
	DialogContent,
	DialogContentText,
	DialogActions,
	makeStyles,
	Theme,
	createStyles,
	Backdrop,
	CircularProgress,
} from "@material-ui/core"
import { useSharedNavStyles } from "../Navbar/_config/style"
import ClientDB from "../../data/client/ClientDatabase"
import HealthCheckDB from "../../data/healthChecks/HealthCheckDatabase"
import ActionChecklistDB from "../../data/ActionChecklist/ActionChecklistDatabase"
import CFCDB from "../../data/CFC/CFCDatabase"
import { removeStorageClient } from "../../util/localStorage/client"
import { useHistory } from "react-router-dom"
import { PrivateRoutes } from "../../util/routes/routes"
import styled, { keyframes, createGlobalStyle } from "styled-components"
import * as AuthService from "../../services/auth-service"
import { Alert } from "@material-ui/lab"

const jump = keyframes`
  from{
    transform: translateY(0)
  }
  to{
    transform: translateY(-3px)
  }
`

const GlobalStyle = createGlobalStyle`
  * {
    padding: 0;
    margin: 0;
    box-sizing: border-box;
    background: #FDF9F3;
  }

  body, html, #root {
    height: 100%;
    font-family: -apple-system, Ubuntu , BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;;
  }
`

const Wrapper = styled.section`
	display: flex;
	justify-content: center;
	align-items: center;
	height: 100%;
	width: 100%;
`

const Form = styled.form`
	margin: 0 auto;
	width: 100%;
	max-width: 414px;
	padding: 1.3rem;
	display: flex;
	flex-direction: column;
	position: relative;
`

const Input = styled.input`
	max-width: 100%;
	padding: 11px 13px;
	background: #f9f9fa;
	color: #2e7d32;
	margin-bottom: 0.9rem;
	border-radius: 4px;
	outline: 0;
	border: 1px solid rgba(245, 245, 245, 0.7);
	font-size: 14px;
	transition: all 0.3s ease-out;
	box-shadow: 0 0 3px rgba(0, 0, 0, 0.1), 0 1px 1px rgba(0, 0, 0, 0.1);
	:focus,
	:hover {
		box-shadow: 0 0 3px rgba(0, 0, 0, 0.15), 0 1px 5px rgba(0, 0, 0, 0.1);
	}
`

const Button = styled.button`
	max-width: 100%;
	padding: 11px 13px;
	color: rgb(253, 249, 243);
	font-weight: 600;
	text-transform: uppercase;
	background: #2e7d32;
	border: none;
	border-radius: 3px;
	outline: 0;
	cursor: pointer;
	margin-top: 0.6rem;
	box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.1);
	transition: all 0.3s ease-out;
	:hover {
		background: #a5d6a7;
		animation: ${jump} 0.2s ease-out forwards;
	}
`

const Title = styled.h2`
	font-weight: normal;
	color: #2a2a29;
	text-shadow: 0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.1);
	text-align: center;
`
export default function Login(): ReactElement {
	const [dados, setDados] = useState({
		email: "",
		password: "",
	})
	const handleSubmit = (e) => {
		e.preventDefault()
		AuthService.login(dados.email, dados.password).then(
			(_) => {
				// if (location.pathname) {
				// 	history.push(location.pathname)
				// } else {
				history.push(PrivateRoutes.ClientList)
				// }

				window.location.reload()
			},
			(error) => {
				setErrorMsg(error)
			}
		)
	}

	const handleChange = (e) => {
		e.preventDefault()
		const { name, value } = e.target
		setDados({ ...dados, [name]: value })
	}

	const history = useHistory()
	const [errorMsg, setErrorMsg] = useState("")

	return (
		<>
			{errorMsg ? <Alert severity="error">{errorMsg}</Alert> : null}
			<GlobalStyle />
			<Wrapper>
				<Form onSubmit={handleSubmit}>
					<Input
						type="email"
						name="email"
						value={dados.email}
						onChange={handleChange}
					/>
					<Input
						type="password"
						name="password"
						value={dados.password}
						onChange={handleChange}
					/>
					<Button>Prijavi se</Button>
				</Form>
			</Wrapper>
		</>
	)
}
